import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);
const KEY = "sseuropa_auth_token";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=checking, null=guest, obj=logged
  const [token, setToken] = useState(() => localStorage.getItem(KEY) || null);

  useEffect(() => {
    let cancelled = false;
    async function check() {
      if (!token) { setUser(null); return; }
      try {
        const { data } = await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!cancelled) setUser(data);
      } catch {
        if (!cancelled) { setUser(null); localStorage.removeItem(KEY); setToken(null); }
      }
    }
    check();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const login = async (matricola, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { matricola, password });
    localStorage.setItem(KEY, data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const changePassword = async (current_password, new_password) => {
    const { data } = await axios.post(
      `${API}/auth/change-password`,
      { current_password, new_password },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
  };

  const logout = () => {
    localStorage.removeItem(KEY);
    setToken(null);
    setUser(null);
  };

  const value = useMemo(
    () => ({ user, token, login, changePassword, logout }),
    [user, token]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
};
